export default [
    {
        path: '/test',
        component: () => import('./test.vue'),
        //children:[],
        //redirect: '',
    }
]